import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  business_name: "360 View LLC",
  phone: "702-929-0390",
  email: "360viewlv@gmail.com",
  headquarters: "Las Vegas, Nevada",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useBusinessSettings() {
  return useContext(SettingsContext) || DEFAULTS;
}
